import { Form, Input } from "antd";
import { FC } from "react";

const BlankSpaceSetting: FC = () => {
  return (
    <>
      <Form.Item label="フィールド名" name={["item_config_data", "element_id"]}>
        <Input />
      </Form.Item>
    </>
  );
};

export default BlankSpaceSetting;
